import { OWNER_RELATION } from '@/shared/constants/other.constants'

export const useIsHolder = (relationCode: string) => relationCode === OWNER_RELATION.CODE